import React from "react";
import { Link, useModel ,DisabledPrompt} from "bcms-react";

import "./styles.css";
import "./mobile.css";
import { SVGAsset } from "res";

/**
 * @function AccountSummaryBrandableLinksWidget
 * @return {React.Component}
 * @exported true
 * @description This is the main widget of the AccountSummaryBrandableLinksWidget
 */
export default function AccountSummaryBrandableLinksWidget(props) {
    const { branding, demos } = useModel();
    const { options } = branding;

    const openAccount = () => {
        let origVersion = branding.options.orig_version_abi22;
        if(origVersion !== "ORIG19") origVersion = "ORIG20";
        window.open(demos[origVersion], "_blank");
    };
    const buildLinks = (link,index)=>{
            if(link === "Edit Accounts View"){
                return <Link to="/editAccountsView/" className="edit-accounts-view-link widget-link set-width" dataPoint={index ===1?"Account_Summary_First_Link":"Edit_Accounts_View_Link"}>Edit Accounts View</Link>
            }
            if(link === "Search"){
                return <DisabledPrompt>
                            <Link to="" className="search-link  widget-link set-width" dataPoint={index ===1?"Account_Summary_First_Link":"Account_Summary_Search_Link"}>
                                <SVGAsset id="MagnifyingGlassIcon" className="search-icon" />
                                <span>Search</span>
                            </Link>
                        </DisabledPrompt> 
               
            }
            if(link === "Download"){
                return <Link to="/download" className="download-link widget-link set-width" dataPoint={index ===1?"Account_Summary_First_Link":"Account_Summary_Download_Link"}>Download</Link>
            }
            if(link === "Open an Account"){
                console.log(options.orig_courseid_abi22 )
                return options.orig_courseid_abi22 == null?
                <DisabledPrompt> 
                    <Link to="" className="open_account-link widget-link set-width" dataPoint={index ===1?"Account_Summary_First_Link":"Account_Summary_Open_account_Link"}>Open an Account</Link>
                </DisabledPrompt> 
            
            :   <Link to="" className="open_account-link widget-link set-width" dataPoint={index ===1?"Account_Summary_First_Link":"Account_Summary_Open_account_Link"} onClick={ openAccount }>Open an Account</Link>
           
                 
            }
            let varLink = link.replaceAll(" ","_") ?? "link";
            return <DisabledPrompt>
                        <Link to="" className={varLink+"-link widget-link set-width"} dataPoint={index ===1?"Account_Summary_First_Link":("Account_Summary_"+varLink)}>{link}</Link>
                    </DisabledPrompt> 
        }
       let links = [1,2,3,4,5];
       links = links.map(function(link){
                    let currentOption = `acctsumwidget_link_${link}_abi22`;
                    if(branding.options[currentOption] !== "undefined" && branding.options[currentOption] !== "None"){
                        return buildLinks(branding.options[currentOption],link);
                    }
                 })
    return (
      <>
        <div className="widget-link-container flex-container flex-horizontal">
            {links}
        </div>        
    
      </>
               
     )              
}
